module.exports = __webpack_public_path__ + "static/img/chengjilogo.fb8f20b2.png";